"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseContractNumberStatuses = exports.parseContractNumberFiles = exports.parseContractNumbersForSelect = exports.parseContractNumber = exports.parseContractNumbers = void 0;
const types_1 = require("api/references/contractNumber/types");
const helper_1 = require("api/helper");
const parsers_1 = require("api/parsers/parsers");
const parsers_2 = require("api/files/parsers");
const parseContractNumbers = (response) => {
    if (response.content === null)
        return { data: null, errors: response.errors, status: response.status };
    const contractNumbers = response.content;
    try {
        return {
            data: contractNumbers.data.map(el => {
                return {
                    id: el.id,
                    number: el.attributes.number,
                    status: el.attributes.status,
                    contractNumberVisualStatus: (0, exports.parseContractNumberStatuses)(el.attributes.status),
                    dateOfPreparation: (0, parsers_1.nullableTransformDate)(el.attributes.dateOfPreparation),
                    procurementId: el.relationships?.procurement?.data.id || null,
                    hasCorrections: el.attributes.hasCorrections,
                    createdAt: (0, parsers_1.transformDate)(el.attributes.createdAt),
                    createdDateTimeAt: (0, parsers_1.transformDateTime)(el.attributes.createdAt),
                    updatedAt: (0, parsers_1.transformDate)(el.attributes.updatedAt),
                    updatedDateTimeAt: (0, parsers_1.transformDateTime)(el.attributes.updatedAt),
                    purchaser: el.relationships?.purchaser && {
                        id: el.relationships.purchaser.data.id,
                        label: el.relationships.purchaser.data.attributes.fullname
                    }
                };
            }),
            status: response.status,
            errors: null,
            meta: (0, parsers_1.transformPagination)(contractNumbers.meta)
        };
    }
    catch (err) {
        (0, helper_1.throwException)(err);
        return helper_1.errorObject;
    }
};
exports.parseContractNumbers = parseContractNumbers;
const parseContractNumber = (response) => {
    if (response.content === null)
        return { data: null, errors: response.errors, status: response.status };
    const contractNumber = response.content;
    try {
        return {
            data: {
                id: contractNumber.data.id,
                number: contractNumber.data.attributes.number,
                contractNumberVisualStatus: (0, exports.parseContractNumberStatuses)(contractNumber.data.attributes.status),
                dateOfPreparation: (0, parsers_1.nullableTransformDate)(contractNumber.data.attributes.dateOfPreparation),
                status: contractNumber.data.attributes.status,
                isBooked: contractNumber.data.attributes.status === types_1.ContractNumberStatus.BOOKED,
                isCancelled: contractNumber.data.attributes.status === types_1.ContractNumberStatus.CANCELED,
                procurement: contractNumber.data.relationships?.procurement?.data.id || null,
                comment: contractNumber.data.attributes.comment,
                purchaser: contractNumber.data.relationships?.purchaser && {
                    id: contractNumber.data.relationships.purchaser.data.id,
                    label: contractNumber.data.relationships.purchaser.data.attributes.fullname
                }
            },
            status: response.status,
            errors: null
        };
    }
    catch (err) {
        (0, helper_1.throwException)(err);
        return helper_1.errorObject;
    }
};
exports.parseContractNumber = parseContractNumber;
const parseContractNumbersForSelect = (response) => {
    if (response.content === null)
        return [];
    const contractNumbers = response.content;
    try {
        return contractNumbers.data.map(el => ({
            id: el.id,
            label: el.attributes.number
        }));
    }
    catch (err) {
        (0, helper_1.throwException)(err);
        return [];
    }
};
exports.parseContractNumbersForSelect = parseContractNumbersForSelect;
const parseContractNumberFiles = (response) => {
    if (response.content === null)
        return { data: null, errors: response.errors, status: response.status };
    const contractNumberFile = response.content.data;
    try {
        return {
            data: (0, parsers_2.parseFileData)(contractNumberFile),
            status: response.status,
            errors: null
        };
    }
    catch (err) {
        (0, helper_1.throwException)(err);
        return helper_1.errorObject;
    }
};
exports.parseContractNumberFiles = parseContractNumberFiles;
const parseContractNumberStatuses = (status) => {
    switch (status) {
        case types_1.ContractNumberStatus.FREE:
            return { name: 'თავისუფალი ', color: 'success' };
        case types_1.ContractNumberStatus.USED:
            return { name: 'დაკავებული', color: 'danger' };
        case types_1.ContractNumberStatus.BOOKED:
            return { name: 'დაჯავშნილი', color: 'warning' };
        case types_1.ContractNumberStatus.DECLINED:
            return { name: 'უარყოფილი', color: 'secondary' };
        case types_1.ContractNumberStatus.CANCELED:
            return { name: 'გაუქმებული', color: 'secondary' };
        case types_1.ContractNumberStatus.RETURNED:
            return { name: 'დაბრუნებული', color: 'secondary' };
    }
};
exports.parseContractNumberStatuses = parseContractNumberStatuses;
